import { useEffect, useState } from 'react';
import { PluginConfig } from '../models/plugin-config';
import { fetchClubSettings } from '../services/club-service';
import { Club } from '../models/club';

type UseClubResult = {
    club: Club | null;
    isLoading: boolean;
    error: string | null;
};

export function useClub(config: PluginConfig | null | undefined): UseClubResult {
    const [club, setClub] = useState<Club | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    useEffect(() => {
        if (!config || isLoading) return;
        setIsLoading(true);
        fetchClubSettings(config.chainId, config.language)
            .then((data) => {
                if (data && data.length) {
                    setClub(data[0]);
                }
            })
            .catch((e) => setError(e.message))
            .finally(() => setIsLoading(false));
    }, [config]);

    return { club, isLoading, error };
}
